module.exports = __webpack_public_path__ + "static/media/union.ceec8d52.svg";